export default __webpack_public_path__ + "053fce35f3df5f0caeb7c8c7269fb714.jpg";